import { useCanvasEditingEnabled } from "../../lib/schedule-art/canvas-state";
import { useMetadataNudgeShortcuts } from "../../lib/metadata-history/use-metadata-nudge-shortcuts";
import { MetadataTargetSelect } from "./MetadataTargetSelect";
import { MetadataPositionFields } from "./MetadataPositionFields";
import { MetadataViewToggles } from "./MetadataViewToggles";
import { MetadataHistoryButtons } from "./MetadataHistoryButtons";

export function MetadataCanvasToolbar() {
  const enabled = useCanvasEditingEnabled();
  useMetadataNudgeShortcuts();
  if (!enabled) return null;

  return (
    <div className="flex flex-wrap items-center gap-1.5 rounded-md border border-neutral-200 bg-neutral-50 p-1.5 text-xs">
      <MetadataTargetSelect />
      <MetadataPositionFields />
      <span className="mx-1 h-5 w-px bg-neutral-200" />
      <MetadataViewToggles />
      <MetadataHistoryButtons />
    </div>
  );
}
